
      export type PossibleTypesResultData = {
  "possibleTypes": {
    "BlockNode": [
      "CodeBlockNode",
      "HeadingNode",
      "IframeNode",
      "ListNode",
      "ParagraphNode",
      "QuoteNode"
    ],
    "InlineNode": [
      "ImageNode",
      "LineBreakNode",
      "LinkNode",
      "TextNode"
    ],
    "Sender": [
      "APIIntegration",
      "MemberUser",
      "Visitor"
    ]
  }
};
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BlockNode": [
      "CodeBlockNode",
      "HeadingNode",
      "IframeNode",
      "ListNode",
      "ParagraphNode",
      "QuoteNode"
    ],
    "InlineNode": [
      "ImageNode",
      "LineBreakNode",
      "LinkNode",
      "TextNode"
    ],
    "Sender": [
      "APIIntegration",
      "MemberUser",
      "Visitor"
    ]
  }
};
      export default result;
    